import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import Insurance from "../../components/InsuranceCharges/Insurance";
import Warehouse from "../../components/WarehouseAddress/Warehouse";


const WarehouseAddressPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
             
                <Breadcrumb title="Warehouse Address" />
                {/* <Insurance/> */}

                <Warehouse/>



            </MasterLayout>
        </>
    );
};

export default WarehouseAddressPage;
